import React, { useState } from 'react';

const SizeModal = ({ item, onAddToCart, onClose }) => {
    // Set the default selected size to the first one in the array
    const [selectedSize, setSelectedSize] = useState(item.sizes[0]);

    if (!item) return null;

    const handleAddToCart = () => {
        const itemToAdd = {
            ...item,
            // FIX: Changed .size to .size_name
            item_id: `${item.item_id}_${selectedSize.size_name.replace(/\s+/g, '-')}`, 
            name: `${item.name} (${selectedSize.size_name})`,
            price: selectedSize.price,
            // Remove the sizes array from the cart item
            sizes: undefined 
        };
        onAddToCart(itemToAdd);
        onClose();
    };

    return (
        <div id="size-modal" className="modal-overlay visible" style={{ display: 'flex' }}>
            <div className="modal-content">
                <button className="modal-close-btn" onClick={onClose}>&times;</button>
                <h3 id="modal-item-name">Select a Size for {item.name}</h3>
                <div id="modal-size-options" className="size-options-container">
                    {item.sizes.map((sizeOption, index) => (
                        <div
                            // FIX: Using index for key as a fallback, and changed .size to .size_name
                            key={index}
                            className={`size-option ${selectedSize.size_name === sizeOption.size_name ? 'selected' : ''}`}
                            onClick={() => setSelectedSize(sizeOption)}
                        >
                            <span className="size-name">{sizeOption.size_name}</span>
                            <span className="size-price">₹{parseFloat(sizeOption.price).toFixed(2)}</span>
                        </div>
                    ))}
                </div>
                <button id="modal-add-to-cart-btn" className="btn checkout-btn" onClick={handleAddToCart}>
                    Add to Order
                </button>
            </div>
        </div>
    );
};

export default SizeModal;